<template>
	<div id="liveManagement">
		<div class="container">
			<!-- <div class="companyInfo">
				<div class="company_avatar">
					{{schoolInfo.logo}}
					<img v-if="schoolInfo.logo" :src="schoolInfo.logo"></img>
					<div class="company_name" v-else>
						{{schoolInfo.company_name?schoolInfo.company_name.substring(0,1):''}}
					</div>
				</div>
				<div class="companyInfoRight">
					<div class="companyInfoName">
						{{ schoolInfo.company_name || '校招平台用户' }}
					</div>
					<div class="tags">
						<div class="item" v-if="schoolInfo.industry">
							{{schoolInfo.industry || ''}}
						</div>
						<div class="item" v-if="schoolInfo.scale">
							{{schoolInfo.scale || ''}}
						</div>
					</div>
				</div>
			</div> -->

			<div class="companyInfoIpt">
				<div class="titleContainer">
					<div class="shu">
					</div>
					<div class="title">
						直播管理
					</div>
				</div>

				<div class="iptContainer" v-for="(item,index) in liveList" :key="index">
					<!-- <div class="avatarContainer">
						<div class="text">
							头像：
						</div>
						<div class="uploadContainer">
							<div class="upload">
								<el-upload class="avatar-uploader" action="https://jsonplaceholder.typicode.com/posts/"
									:show-file-list="false" :on-success="handleAvatarSuccess"
									:before-upload="beforeAvatarUpload">
									<img v-if="imageUrl" :src="imageUrl" class="avatar">
									<div class="avatarUploader" v-else>
										<i class="el-icon-plus avatar-uploader-icon"></i>
										<span>点击上传</span>
									</div>
								</el-upload>
							</div>
							<div class="uploadText">
								建议尺寸1：1，JPG、PNG格式， 图片小于 5M。
							</div>
						</div>
					</div> -->
					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span>直播操作：</span>
						</div>
						<el-button type="primary" style="background: #0084FF;" v-if="item.xet_alive_code"
							@click="liveStreaming(item.xet_alive_code)">点击开启直播</el-button>
						<el-button type="danger" :disabled='item.id?false:true' @click="deleteItem(index)">删除直播</el-button>
					</div>

					<div class="ipt" style="margin-bottom: 30px;" @click="selectTime(index)">
						<div class="text">
							<span style="color:#FF4A4A">*</span>直播时间段：
						</div>

						<el-date-picker v-model="item.value1" @change='timeChange(index)' type="datetimerange" start-placeholder="开始日期"
							end-placeholder="结束日期" :picker-options="pickerOptions">
						</el-date-picker>

						<!-- <el-date-picker v-model="item.stime" @change='startTimeChange' type="datetime" style="margin-right: 10px;"
							placeholder="请选择直播开始时间" :picker-options="pickerOptions">
						</el-date-picker>
						
						<el-date-picker v-model="item.etime" :disabled='item.isSelect' type="datetime"
							placeholder="请选择直播结束时间" :picker-options="pickerOptions1">
						</el-date-picker> -->
					</div>


					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>直播标题：
						</div>
						<el-input v-model="item.title" placeholder="请输入直播标题" maxlength="15"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>主讲人：
						</div>
						<el-input v-model="item.event_person" placeholder="请输入主讲人" maxlength="15"></el-input>
					</div>



					<div class="ipt" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>主讲人头衔：
						</div>
						<el-input v-model="item.header_intr" placeholder="请输入主讲人头衔" maxlength="20"></el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px;align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>主讲人介绍：
						</div>
						<el-input type="textarea" autosize placeholder="请输入主讲人介绍" v-model="item.person_desc">
						</el-input>
					</div>

					<div class="ipt" style="margin-bottom: 30px; align-items: baseline;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>直播内容：
						</div>
						<el-input type="textarea" autosize v-model="item.event_desc" placeholder="请输入直播内容"></el-input>
					</div>

					<div class="companyContainer" style="margin-bottom: 30px;">
						<div class="text">
							<span style="color:#FF4A4A">*</span>直播海报：
						</div>

						<div class="company">
							<div class="top">
								<div class="" style="font-weight: 400;font-size: 14px;color: #C0C4CC;flex: 1;">
									请上传您所需要的直播海报
								</div>
								<!-- <el-input v-model="name"  placeholder="请上传您所需要的直播海报"></el-input> -->
								<div class="uplodadCompany1">
									<el-upload class="avatar-uploader1"
										action="https://np.sx985.com/admin/upload/uploadOssFile?admin_id=3"
										:show-file-list="false" :on-success="handleAvatarSuccess"
										:before-upload="beforeAvatarUpload">
										<!-- <img  src="" class="avatar"> -->
										<div class="uplodadCompany" @click="selectIndex(index)">
											<img src="../img/xiangji.png" alt="" />
											<div class="btn">
												上传直播海报
											</div>
										</div>
									</el-upload>
								</div>
							</div>
							<div class="companyImg">
								<img :src="item.event_img" alt="" v-if="item.event_img" />
								<div v-else class=""
									style="width: 195px;height: 120px;background: #f9fbff;border-radius: 5px;text-align: center;line-height: 120px;margin-right: 15px;font-weight: 500;font-size: 18px;color: #BEC6D2;">
									直播海报
								</div>
								<div class="">
									<span style="margin-bottom: 5px;">注意事项: </span>
									<span style="margin-bottom: 5px;">建议图片比例750x560</span>
									<span style="margin-bottom: 5px;">图片大小不超过 10M</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="addNewContainer">
					<div class="addNew" @click="addLive">
						添加新的直播 +
					</div>
				</div>
				<div class="btnContainer">
					<!-- <el-button type="primary">公司预览</el-button> -->
					<el-button type="primary" @click="submit">保存</el-button>
				</div>
			</div>
		</div>

		<el-dialog :visible.sync="dialogVisible" :show-close='false' width="800px">
			<div class="elDialog">
				<img class="close" @click="closeElDialog" src="../img/close.png" alt="" />
				<div class="main">
					<div class="title">直播二维码</div>
					<div class="qrcodeContainer">
						<div class="qrcode">
							<img :src="xet_alive_code" alt="" />

							<div class="hite1">
								扫描<span style="color:#0084FF;">识别二维码</span>
							</div>
							<div class="hite2">
								开启直播
							</div>
						</div>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from 'vuex'
	export default {
		data() {
			return {
				dialogVisible: false,
				idx: 0,
				imageUrl: '',
				name: '',
				textarea1: '',
				options: [{
					value: '男',
					label: '男'
				}, {
					value: '女',
					label: '女'
				}],
				value: '',

				startTime: '',
				endTime: '',

				pickerOptions: {
					disabledDate(time) {
						return time.getTime() < Date.now()-86400000;
					}
				},
				pickerOptions1: {
					disabledDate: this.disabledDate,
				},
				// stime: '', //直播开始时间
				// etime: '', //直播结束时间
				// title: '', //直播标题
				// event_person: '', //主讲人
				// person_desc: '', //主讲人介绍
				// header_intr: '', //主讲人头衔
				// event_desc: '', //直播内容简介
				// event_img: '', //直播海报
				liveList: [{
					stime: '', //直播开始时间
					etime: '', //直播结束时间
					title: '', //直播标题
					event_person: '', //主讲人
					person_desc: '', //主讲人介绍
					header_intr: '', //主讲人头衔
					event_desc: '', //直播内容简介
					event_img: '', //直播海报
					isSelect: true,
				}],
				selectIdx: 0,

				
				value1:'',
				xet_alive_code: '',
			};
		},
		computed: {
			...mapState({
				nextToken: state => state.nextToken,
				userInfo: state => state.userInfo,
				schoolInfo: state => state.schoolData,
			}),
		},
		mounted() {
			
			this.getkyjoblist()
			// this.$util.post(
			// 	"/login/login", {
			// 		username: this.ruleForm.username,
			// 		password: this.$md5(this.ruleForm.pass),
			// 	},
			// 	(res) => {
			// 		
			// 		if (res.code == 1) {
			// 			localStorage.setItem("token", res.data.token);
			// 			this.$router.push({
			// 				path: "/main",
			// 				// query: {
			// 				//   id: 1,
			// 				// },
			// 			});
			// 		}
			// 	}
			// );
		},
		methods: {
			...mapMutations(['setIslogin']),
			timeChange(index){
				// console.log(this.$getTime('-',1,this.liveList[index].value1[0]))
				// if(index){
				// 	this.liveList[index].stime = this.$getTime('-',1,this.liveList[index].value1[0])
				// 	this.liveList[index].etime = this.$getTime('-',1,this.liveList[index].value1[1])
				// }else{
				// 	this.liveList[index].stime = ''
				// 	this.liveList[index].etime = ''
				// }
				
				
			},
			liveStreaming(str) {
				this.xet_alive_code = str
				this.dialogVisible = true
			},
			closeElDialog() {
				this.dialogVisible = false
			},
			// new Date(stime).getTime()
			async submit() {
				if (!this.nextToken) {
					this.$confirm('使用完整功能，请登录使用！', '提示', {
						confirmButtonText: '去登录',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.$router.push({
							path: '/login',
							// query: {
							//   id: 1,
							// },
						})
					}).catch(() => {
				
					});
					return
				}
				let liveList = JSON.parse(JSON.stringify(this.liveList))
                
				let isNull = ''
				for (let i = 0; i < liveList.length; i++) {
                    // liveList[i].value1 = liveList[i].value1.trim()
                    liveList[i].title = liveList[i].title.trim()
                    liveList[i].event_person= liveList[i].event_person.trim()
                    liveList[i].person_desc= liveList[i].person_desc.trim()
                    liveList[i].header_intr= liveList[i].header_intr.trim()
                    liveList[i].event_desc = liveList[i].event_desc.trim()
                    liveList[i].event_img = liveList[i].event_img.trim()
                   
                   
                    if(!liveList[i].event_img){
                        isNull = '请上传直播海报'
                    }
					if(!liveList[i].event_desc){
					    isNull = '请填写直播内容'
					}
					if(!liveList[i].person_desc){
					    isNull = '请填写主讲人介绍'
					}
					if(!liveList[i].header_intr){
					    isNull = '请填写主讲人头衔'
					}
					if(!liveList[i].event_person){
					    isNull = '请填写主讲人名称'
					}
					if(!liveList[i].title){
					    isNull = '请填写直播标题'
					}
					if(!liveList[i].value1){
					    isNull = '请选择直播时间段'
					}
					// if (liveList[i].value1 ==''|| liveList[i].title == '' || liveList[i]
					// 	.event_person == '' || liveList[i].person_desc == '' || liveList[i].header_intr == '' ||
					// 	liveList[i].event_desc == '' || liveList[i].event_img == '') {
					// 	isNull = true
					// 	break
					// }
				}
				if (isNull) {
					this.$message({
						message: isNull,
						type: 'error'
					});
					return 
				}
				liveList.forEach((item, index, arr) => {
					arr[index].stime = this.$getTime('-',1,this.liveList[index].value1[0])
					arr[index].etime = this.$getTime('-',1,this.liveList[index].value1[1])
				})

				// if(giftList1.length>0){
				console.log(liveList)
				// return
				if (liveList.length > 0) {
					await Promise.all(liveList.map(async item => {
						await this.addLiveEvent(item);
					})).then(() => {
						
						this.$message({
							message: '保存成功',
							type: 'success'
						});
						setTimeout(() => {
							this.$router.push({
								path: "/meeting",
							});
						}, 1000)
					})
				}
				// }else{
				// 	this.$message({
				// 		message: '请填写直播信息',
				// 		type: 'error'
				// 	});
				// }

			},
			addLiveEvent(item) {
				return new Promise((resolve) => {
					let obj = {
						stype: 5,
						admin_id: this.schoolInfo.admin_id,
						...item
					}
					if (item.id) {
						obj.live_id = item.id
					}
					this.$util.post(
						"v2/addLiveEvent", {
							...obj
						},

						(res) => {
							
							if (res.code == 200) {
								
								this.getkyjoblist()
								resolve(res)
							}
						}
					);
				})
			},
			deleteItem(index) {
				if (this.liveList[index].id) {
					const that = this
					that.$confirm('是否删除该活动预告?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						let obj = {
							live_id: that.liveList[index].id,
							admin_id: that.schoolInfo.admin_id,
						}
						this.$util.post(
							"v2/delLiveEvent", {
								...obj
							},
							(res) => {
								
								if (res.code == 200) {
									if (that.liveList.length == 1) {
										that.liveList.splice(index, 1)
										that.liveList.push({
											stime: '', //直播开始时间
											etime: '', //直播结束时间
											title: '', //直播标题
											event_person: '', //主讲人
											person_desc: '', //主讲人介绍
											header_intr: '', //主讲人头衔
											event_desc: '', //直播内容简介
											event_img: '', //直播海报
											isSelect: true,
											value1:'',
										})
									} else {
										that.liveList.splice(index, 1)
									}
									this.$message({
										type: 'success',
										message: '删除成功!'
									});
								}
							}
						);
					}).catch(() => {

					});
				} else {
					
					if (this.liveList.length == 1) {
						this.liveList.splice(index, 1)
						this.liveList.push({
							stime: '', //直播开始时间
							etime: '', //直播结束时间
							title: '', //直播标题
							event_person: '', //主讲人
							person_desc: '', //主讲人介绍
							header_intr: '', //主讲人头衔
							event_desc: '', //直播内容简介
							event_img: '', //直播海报
							isSelect: true,
							value1:'',
						})
					} else {
						this.liveList.splice(index, 1)
					}
				}
			},
			getkyjoblist() {
				this.$util.get(
					"v2/getLiveEvent", {
						stype: 5,
						admin_id: this.schoolInfo.admin_id,
					}, (res) => {
						if (res.code == 200) {
							
							let liveList = res.data.map((item) => {
								return {
									...item,
									stime: new Date(item.stime),
									etime: new Date(item.etime),
									value1:[new Date(item.stime),new Date(item.etime)]
								}
							})
							if (liveList.length == 0) {
								liveList.push({
									stime: '', //直播开始时间
									etime: '', //直播结束时间
									title: '', //直播标题
									event_person: '', //主讲人
									person_desc: '', //主讲人介绍
									header_intr: '', //主讲人头衔
									event_desc: '', //直播内容简介
									event_img: '', //直播海报
									isSelect: true,
									value1:'',
								})
							}
							this.liveList = liveList
							
						} else {
							// this.$message({
							// 	showClose: true,
							// 	message: res.msg,
							// 	type: 'error'
							// });
						}
					}
				);
			},
			selectIndex(index) {
				this.idx = index
			},
			handleAvatarSuccess(res, file) {
				this.liveList[this.idx].event_img = file.response.data.fileUrl;
			},
			beforeAvatarUpload(file) {
				
				const isJPG = file.type === 'image/jpeg';
				const isPNG = file.type === 'image/png';
				const isLt2M = file.size / 1024 / 1024 < 10;
				let img = isJPG || isPNG
				if (!isJPG && !isPNG) {
					this.$message.error('上传图片格式错误!');
					return
				}
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 10MB!');
					return
				}
				
				return isLt2M && img;
			},
			$getTime(symbol = '-', status = 0, time = Date.now()) {
				let date = new Date(time)
				let Y = date.getFullYear() + symbol

				let M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + symbol
				let D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '

				let H = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
				let Minu = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
				let S = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
				switch (status) {
					case 0:
						return Y + M + D;
					case 1:
						return Y + M + D + H + Minu + S;
					default:
						break;
				}
			},
			getTime(dateTimeString) {
				const dateTime = new Date(dateTimeString);
				
				const year = dateTime.getUTCFullYear();
				const month = String(dateTime.getUTCMonth() + 1).padStart(2, '0');
				const day = String(dateTime.getUTCDate()).padStart(2, '0');
				const hour = String(dateTime.getUTCHours()).padStart(2, '0');
				const minute = String(dateTime.getUTCMinutes()).padStart(2, '0');
				const second = String(dateTime.getUTCSeconds()).padStart(2, '0');

				const formattedDateTime = `${year}-${month}-${day} ${hour}:${minute}:${second}`;

				
				return formattedDateTime
			},
			selectTime(idx) {
				
				this.selectIdx = idx
			},

			startTimeChange(val) {
				
				this.liveList[this.selectIdx].isSelect = false
				this.liveList[this.selectIdx].etime = ''
			},
			disabledDate(time) {
				if (this.liveList[this.selectIdx].stime !== '') {
					return time.getTime() <= this.liveList[this.selectIdx].stime.getTime();
				} else {
					return false
				}

			},



			addLive() {
				this.liveList.push({
					stime: '', //直播开始时间
					etime: '', //直播结束时间
					title: '', //直播标题
					event_person: '', //主讲人
					person_desc: '', //主讲人介绍
					header_intr: '', //主讲人头衔
					event_desc: '', //直播内容简介
					event_img: '', //直播海报
					isSelect: true,
					value1:'',
				})
			},

		},
		components: {},
	};
</script>
<style>
	#liveManagement .avatar-uploader1 .el-upload {
		border: none !important;
	}
	#liveManagement .el-date-editor.el-input__inner{
		flex: 1 !important;
	}
</style>
<style lang="less" scoped>
	.container {
		width: 100%;
		padding: 0 40px;

		.companyInfo {
			width: 100%;
			padding: 20px 0 20px 0;
			border-bottom: 1px solid #EEEEEE;
			font-size: 0;
			display: flex;
			align-items: center;
			margin-bottom: 25px;

			img {
				width: 57px;
				height: 57px;
				border-radius: 50%;
				margin-right: 10px;
			}

			.companyInfoRight {
				display: flex;
				justify-content: center;
				flex-direction: column;

				.companyInfoName {
					font-weight: 500;
					font-size: 18px;
					color: #2D3C50;
					margin-bottom: 10px;
				}

				.tags {
					display: flex;
					align-items: center;

					.item {
						padding: 2px 4px;
						border-radius: 5px;
						border: 1px solid #AEAEAE;
						font-weight: 500;
						font-size: 12px;
						color: #AEAEAE;
						margin-right: 5px;
					}
				}
			}
		}

		.companyInfoIpt {
			padding: 20px 0 0 0;

			.titleContainer {
				display: flex;
				align-items: center;
				margin-bottom: 30px;

				.shu {
					width: 2px;
					height: 13px;
					background: #1472FF;
					margin-right: 7px;
				}

				.title {
					font-weight: bold;
					font-size: 16px;
					color: #333333;
				}
			}

			.iptContainer {

				// .avatarContainer {
				// 	display: flex;
				// 	// align-items: center;
				// 	align-items: flex-start;
				// 	margin-bottom: 30px;

				// 	.text {
				// 		width: 100px;
				// 		display: flex;
				// 		align-items: center;
				// 		font-weight: 500;
				// 		font-size: 18px;
				// 		color: #333333;
				// 		margin-right: 20px;
				// 	}

				// 	.upload {
				// 		margin-right: 20px;
				// 	}

				// 	.uploadContainer {
				// 		display: flex;
				// 		align-items: center;

				// 		.uploadText {
				// 			width: 310px;
				// 			font-weight: 500;
				// 			font-size: 16px;
				// 			color: #999999;
				// 		}
				// 	}

				// }

				.ipt {
					width: 700px;
					display: flex;
					align-items: center;
					margin-bottom: 28px;

					.text {
						// width: 135px;
						width: 93px;
						display: flex;
						align-items: center;
						margin-right: 10px;
						display: flex;
						align-items: center;
						font-weight: 500;
						font-size: 14px;
						color: #000;
						justify-content: flex-end;
						span {
							font-weight: 500;
							font-size: 14px;
							color: #000;
						}
					}

					.el-input {
						flex: 1 !important;
					}

					.el-select {
						flex: 1 !important;
					}

					.el-textarea {
						flex: 1 !important;
					}
				}

			}

			.btnContainer {
				width: 700px;
				display: flex;
				justify-content: flex-end;
				margin-bottom: 60px;

				// .el-button--primary {
				// 	background-color: #0084FF !important;
				// 	border-color: #0084FF !important;
				// 	// border-radius: 10px !important;
				// }
			}
		}


	}

	.companyContainer {
		display: flex;
		align-items: flex-start;
		width: 700px;

		.text {
			width: 93px;
			display: flex;
			align-items: center;
			justify-content: flex-end;
			font-weight: 400;
			font-size: 14px;
			color: #000;
			margin-right: 10px;
		}

		.el-input {
			flex: 1 !important;
		}

		.company {
			flex: 1;
			background: #FFFFFF;
			border-radius: 5px;
			border: 1px solid #DCDFE6;
			box-sizing: border-box;
			padding: 15px 15px 20px 15px;

			.top {
				display: flex;
				align-items: center;
				width: 100%;
				border-bottom: 1px solid #dcdcdc69;
				margin-bottom: 20px;

				padding: 0 5px 15px 5px;

				.uplodadCompany1 {}

				.uplodadCompany {
					display: flex;
					align-items: center;
					font-size: 0;
					margin-left: 10px;

					img {
						width: 20px;
						height: 20px;
						margin-right: 12px;
					}

					.btn {
						font-weight: 500;
						font-size: 14px;
						color: #3A84E9;
					}
				}
			}

			.companyImg {
				display: flex;
				align-items: center;
				// padding: 0 15px;
				font-size: 0;

				img {
					width: 195px;
					height: 120px;
					margin-right: 15px;
				}

				div {
					font-weight: 500;
					font-size: 14px;
					color: #999;
					display: flex;
					// align-items: center;
					justify-content: space-between;
					flex-direction: column;
				}

			}
		}
	}

	.addNewContainer {
		width: 700px;
		display: flex;
		// align-items: flex-end;
		justify-content: flex-end;
		margin-bottom: 30px;

		.addNew {
			width: 600px;
			height: 60px;
			background: #f9fbff;
			border-radius: 5px;

			text-align: center;
			line-height: 60px;
			font-weight: 500;
			font-size: 14px;
			color: #3A84E9;
			cursor: pointer;
		}
	}
	
	.elDialog {
		position: relative;
		font-size: 0;
	
		.main {
			box-sizing: border-box;
			padding: 30px 50px 50px 50px;
			background: #ffffff;
			border-radius: 10px;
	
			.title {
				font-weight: bold;
				font-size: 16px;
				color: #2a2929;
				margin-bottom: 30px;
			}
		}
	
		.close {
			position: absolute;
			top: -28px;
			right: -28px;
			width: 32px;
			height: 32px;
			cursor: pointer;
		}
	}
	.qrcodeContainer {
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
	
		.qrcode {
			padding: 50px 100px;
			// width: 410px;
			// height: 390px;
			background: #FFFFFF;
			border-radius: 10px;
			border: 4px solid #0084FF;
	
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
			font-size: 0;
	
			img {
				width: 208px;
				height: 208px;
				margin-bottom: 37px;
			}
	
			.hite1 {
				font-weight: bold;
				font-size: 24px;
				color: #333333;
				margin-bottom: 17px;
			}
	
			.hite2 {
				font-weight: 500;
				font-size: 18px;
				color: #333333;
			}
		}
	}
</style>

<style>
	#register .el-input__inner {
		font-size: 16px;
	}
	#liveManagement  .el-dialog {
		background: initial;
		box-shadow: initial;
	}
	.companyContainer .el-input__inner {
		border: none !important;
		padding: 0 !important;
	}

	.avatar-uploader .el-upload {
		border: 1px solid #E5E5E5;
		border-radius: 50%;
		cursor: pointer;
		position: relative;
		overflow: hidden;
		background: #F5F7FA;

		display: flex;
		align-items: center;
		flex-direction: column;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.avatarUploader {
		width: 80px;
		height: 80px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: center;
	}

	.avatar-uploader-icon {
		font-size: 14px;
		color: #8c939d;
		margin-bottom: 5px;
	}

	.avatar-uploader span {
		font-weight: 400;
		font-size: 14px;
		color: #999999;
	}

	.avatar {
		width: 178px;
		height: 178px;
		display: block;
	}
</style>